import { Pog } from "@CommonTypes/merchflow/pog/pog";
import { PrimitiveAtom, useSetAtom } from "jotai";
import { usePogAtomActions } from "src/components/Planogram/store/actions";
import {
  planogramSelectedShelfAtom,
  planogramSelectedShelvesAtom,
} from "src/components/PlanogramExtensions/store/atoms";
import { Button, Color, Flex, Text } from "src/elements";

interface Props {
  pogAtom: PrimitiveAtom<Pog>;
}

export const NoShelf = ({ pogAtom }: Props) => {
  const { addNewShelf } = usePogAtomActions(pogAtom);
  const setSelectedShelf = useSetAtom(planogramSelectedShelfAtom);
  const setSelectedShelves = useSetAtom(planogramSelectedShelvesAtom);

  const startAddingNewFixture = () => {
    const newShelf = addNewShelf(1);
    setSelectedShelf(newShelf);
    setSelectedShelves(newShelf ? [newShelf.uniqueId] : []);
  };

  return (
    <Flex column flexGrow>
      <Flex flexGrow justify="center" align="center">
        <Text variant="h3" color={Color.spaceGray}>
          Add New Shelf
        </Text>
      </Flex>

      <Flex padding="10px">
        <Button width="100%" onClick={startAddingNewFixture} variant="inverted">
          Add New Shelf
        </Button>
      </Flex>
    </Flex>
  );
};
